const CompanyDetailFields = [
  [
    {
      fieldId: "merchandiseType",
      fieldLabel: "Vendor Fulfillment Type",
      required: true,
      fieldType: "select",
      length: "2",
      toolTipId: "toolTipFullFillType",
      validateType: "req",
      toolTipText: "Type of Fulfillment method.",
      option: [
        {
          optionName: "VDF",
          optionValue: "Vendor Direct Fulfillment",
        },
        {
          optionName: "Owned Inventory",
          optionValue: "Traditional Vendor (Owned Inventory)",
        },
        {
          optionName: "MP",
          optionValue: "Market Place",
        },
        {
          optionName: "Consignment",
          optionValue: "Consignment",
        },
      ],
    },
    {
      fieldId: "numberOfUpcToDropShip",
      fieldLabel: "Number of U.P.C.'s",
      required: true,
      fieldType: "text",
      placeHolder: "10000",
      length: "2",
      toolTipId: "toolTipNoOfUPC",
      validateType: "numeric",
      toolTipText:
        "Number of U.P.C.'s a vendor plans to offer across all selling channels.",
    },
    {
      fieldId: "openRANumber",
      fieldLabel: "Open RA# for RTV",
      required: false,
      fieldType: "text",
      placeHolder: "1234",
      validateType: "openRANumeric",
      length: "2",
      toolTipId: "toolTipOpenRaNo",
      toolTipText: "Return Authorization Number for Returns to Vendor.",
    },
    {
      fieldId: "ediProvider",
      fieldLabel: "EDI Provider",
      required: false,
      fieldType: "text",
      placeHolder: "EDI Provider",
      maxLength: 100,
    },
    {
      fieldId: "companyType",
      fieldLabel: "Company Type",
      required: true,
      fieldType: "select",
      length: "1",
      toolTipId: "toolTipCompanyType",
      validateType: "req",
      toolTipText: "Type of Company",
    },
  ],
  [
    {
      fieldId: "merchantFirstName",
      fieldLabel: "Merchant First Name",
      fieldType: "text",
      placeHolder: "John",
      length: "2",
      toolTipId: "toolTipMercFirstName",
      validateType: "merchantFirstNameValid",
      required: true,
      toolTipText: "First Name of the Merchant who invited vendor.",
    },
    {
      fieldId: "merchantLastName",
      fieldLabel: "Merchant Last Name",
      fieldType: "text",
      placeHolder: "Doe",
      length: "2",
      toolTipId: "toolTipMercLastName",
      validateType: "merchantLastNameValid",
      required: true,
      toolTipText: "Last Name of the Merchant who invited Vendor.",
    },
    {
      fieldId: "merchantEmail",
      fieldLabel: "Merchant Email",
      fieldType: "text",
      required: true,
      placeHolder: "john.doe@email.com",
      validateType: "email",
      length: "2",
      toolTipId: "toolTipMercEmail",
      toolTipText: "Email address of the Merchant who invited Vendor.",
    },
  ],
  [
    {
      fieldId: "certifiedAsMinority",
      fieldLabel:
        "Is this vendor an MBE and/or WBE (Minority- or Women-Owned Business Enterprise)? To be considered an MBE/WBE, the business must be a U.S.-based business that is at least 51% owned, controlled, and operated by one or more minority US citizens or legal permanent residents who is either Black, Hispanic/Latino, Asian-American, Native American descent, woman, LGBTQ, a veteran, or person with disabilities. If yes to MBE or WBE, the affidavit or certification must be provided to Macys.",
      fieldValue:
        "Is this vendor an MBE and/or WBE (Minority- or Women-Owned Business Enterprise)? To be considered an MBE/WBE, the business must be a U.S.-based business that is at least 51% owned, controlled, and operated by one or more minority US citizens or legal permanent residents who is either Black, Hispanic/Latino, Asian-American, Native American descent, woman, LGBTQ, a veteran, or person with disabilities. If yes to MBE or WBE, the affidavit or certification must be provided to Macys.",
      fieldType: "radio",
      validateType: "req",
      length: "12",
      option: [
        {
          optionName: "yes",
          optionValue: "Yes",
          optionType: "radio",
        },
        {
          optionName: "no",
          optionValue: "No",
          optionType: "radio",
        },
      ],
    },
  ],
  [
    {
      fieldId: "isUPSEnabled",
      fieldLabel: "Do you have a UPS Account #?",
      fieldValue: "Do you have a UPS Account #?",
      fieldType: "isUPSEnabled",
      required: false,
      length: "4",
      option: [
        {
          optionName: "Yes",
          optionValue: "Yes",
          optionType: "radio",
        },
        {
          optionName: "No",
          optionValue: "No",
          optionType: "radio",
        },
      ],
    },
  ],
];

export const CompanyBrandName = {
  fieldId: "brandName",
  fieldLabel: "Brand Name",
  required: true,
  fieldType: "text",
  placeHolder: "Alfani",
  length: 4,
  toolTipId: "toolTipBrandName",
  validateType: "brandNameValid",
  toolTipText: "Brand Name(s) on the product.",
};

export const CompanyBrandUrl = {
  fieldId: "brandUrl",
  fieldLabel: "Brand URL",
  required: false,
  fieldType: "text",
  placeHolder: "http://www.alfani.com",
  length: 6,
  toolTipId: "toolTipBrandUrl",
  validateType: "url",
  toolTipText: "Brand's URL/Website.",
};

export const DeleteBrand = {
  fieldId: "deleteBrand",
  fieldLabel: "- Delete",
  fieldType: "submit",
  automationId: "deleteBrand",
  length: 2,
};

export const MBEWBEContractCheck = [
  {
    fieldId: "isAffidavit",
    fieldType: "radio",
    validateType: "req",
    length: "12",
    option: [
      {
        optionName:
          "I will upload prior certification from an advocacy group in the Document Center.",
        optionValue: "documentUpload",
        optionType: "radio",
      },
      {
        optionName:
          "The owner or CEO of you company will sign an affidavit through Adobe Sign (directly within this application).",
        optionValue: "contractUpload",
        optionType: "radio",
      },
    ],
  },
];

export const MBEWBEFields = [
  {
    fieldId: "mbeStatus",
    fieldLabel: "Minority Owned Business Status",
    required: true,
    fieldType: "select",
    length: "2",
    toolTipId: "toolTipMinorityOwnedBusinessStatus",
    validateType: "req",
    toolTipText: "Type of Minority Owned Business Status.",
    option: [
      {
        optionName: "Minority-owned",
        optionValue: "Minority-owned",
      },
      {
        optionName: "NOT Minority-owned",
        optionValue: "NOT Minority-owned",
      },
    ],
  },
  {
    fieldId: "mbeGroups",
    fieldLabel: "Minority Owned Business Groups",
    required: false,
    fieldType: "searchSelect",
    length: "2",
    toolTipId: "toolTipMinorityOwnedBusinessGroups",
    validateType: "req",
    toolTipText: "Type of Minority Owned Business Groups.",
    option: [
      {
        label: "Asian-Pacific American",
        value: "Asian-Pacific American",
      },
      {
        label: "Asian-Indian American",
        value: "Asian-Indian American",
      },
      {
        label: "Black/African American",
        value: "Black/African American",
      },
      {
        label: "Hispanic American",
        value: "Hispanic American",
      },
      {
        label: "Native American",
        value: "Native American",
      },
      {
        label: "LGBTQ+",
        value: "LGBTQ+",
      },
      {
        label: "Person with a disability",
        value: "Person with a disability",
      },
      {
        label: "Veteran",
        value: "Veteran",
      },
    ],
  },
  {
    fieldId: "wbeStatus",
    fieldLabel: "Women Owned Business Status",
    required: true,
    fieldType: "select",
    length: "2",
    toolTipId: "toolTipWomenOwnedBusinessStatus",
    validateType: "req",
    toolTipText: "Type of Women Owned Business Status.",
    option: [
      {
        optionName: "Women-owned",
        optionValue: "Women-owned",
      },
      {
        optionName: "NOT Women-owned",
        optionValue: "NOT Women-owned",
      },
    ],
  },
  {
    fieldId: "ceoEmail",
    fieldLabel: "CEO Email",
    fieldType: "text",
    required: true,
    placeHolder: "john.doe@email.com",
    validateType: "email",
    length: "2",
    toolTipId: "toolTipCEOEmail",
    toolTipText: "Email address of the CEO of Vendor.",
  },
  {
    fieldId: "organization",
    fieldLabel: "Organization",
    required: true,
    fieldType: "searchSelect",
    length: "2",
    toolTipId: "toolTipOrganization",
    validateType: "req",
    toolTipText: "Type of Organization.",
    option: [
      {
        label: "Macy's",
        value: "Macy's",
      },
      {
        label: "Bloomingdale's",
        value: "Bloomingdale's",
      },
      {
        label: "Bluemercury",
        value: "Bluemercury",
      },
    ],
  },
  {
    fieldId: "website",
    fieldLabel: "Website",
    required: false,
    fieldType: "text",
    placeHolder: "http://www.alfani.com",
    length: 4,
    toolTipId: "toolTipWebsite",
    validateType: "brandNameValid",
    toolTipText: "Website of the vendor.",
  },
  {
    fieldId: "avgEmployees",
    fieldLabel:
      "Average number of employees over last three completed fiscal years",
    required: true,
    fieldType: "text",
    placeHolder: "26",
    length: "2",
    toolTipId: "toolTipAvgEmployees",
    validateType: "numeric",
    toolTipText:
      "Average number of employees over last three completed fiscal years.",
  },
  {
    fieldId: "avgCompletedSales",
    fieldLabel: "Average company sales over last three completed years",
    required: true,
    fieldType: "USDNumber",
    placeHolder: "$2,602",
    length: "2",
    toolTipId: "toolTipAvgCompletedSales",
    validateType: "numeric",
    toolTipText: "Average company sales over last three completed years",
    maxLength: 15,
  },
  {
    fieldId: "federalId",
    fieldLabel: "Federal Tax ID",
    required: false,
    fieldType: "text",
    placeHolder: "260219860",
    length: 4,
    toolTipId: "toolTipFederalTaxID",
    validateType: "brandNameValid",
    toolTipText: "Federal Tax ID of the vendor.",
    maxLength: 9,
  },
  {
    fieldId: "fax",
    fieldLabel: "Fax",
    required: false,
    fieldType: "text",
    placeHolder: "(123) 456-7890",
    length: 4,
    toolTipId: "toolTipFax",
    validateType: "brandNameValid",
    toolTipText: "Fax of the vendor.",
    maxLength: 10,
  },
];

export default CompanyDetailFields;
